import { createFileRoute } from '@tanstack/react-router'
import { AssembliesPage } from '../../../components/assemblies/AssembliesPage'

/** General assemblies (spec 2026-10-05-01). The building filter lives in the URL. */
export const Route = createFileRoute('/$org/assemblies/')({
  component: AssembliesPage,
  validateSearch: (search: Record<string, unknown>) => ({
    asset: search.asset ? String(search.asset) : undefined,
  }),
})
